import { render, staticRenderFns } from "./Statistics3.vue?vue&type=template&id=5139e019&scoped=true"
import script from "./Statistics3.vue?vue&type=script&lang=js"
export * from "./Statistics3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139e019",
  null
  
)

export default component.exports